/**
 * A celebration moment: a new personal best, a match win. A single
 * incrementing counter rather than a boolean: `App.svelte`
 * hands it straight to `nav/ConfettiBurst.svelte`'s `trigger` prop, which
 * fires its own burst effect on *every* increment, including two wins in a
 * row with the same value it would otherwise have ignored as "unchanged".
 */
export const celebration = $state({ trigger: 0 });

export function celebrate(): void {
  celebration.trigger += 1;
}
